module.exports = __webpack_public_path__ + "img/icono_personas.dc24fe24.svg";